import * as ActionTypes from 'actions';
import moment from 'moment';
import isEmpty from 'lodash/isEmpty';

import Calendar from 'lib/Calendar';

/* eslint no-console: ["error", { allow: ["error"] }] */

const initialState = {
  events: {},
};

export default function(state = initialState, action = {}) {
  const { type, response, error, id } = action;
  const { events } = state;

  switch (type) {
  case ActionTypes.EDIT_EVENT_LOAD_REQUEST:
    events[id] = { id, isLoading: true };

    return Object.assign({}, state, { events });

  case ActionTypes.EDIT_EVENT_LOAD_SUCCESS: {
    const event = response;

    event.has_setup_breakdown = !isEmpty(event.time_setup) || !isEmpty(event.time_breakdown);

    // Support html entity encoded fields
    event.name = unescape(event.name || '');
    event.description = unescape(event.description || '');
    event.setup_instructions = unescape(event.setup_instructions || '');
    event.notes = unescape(event.notes || '');

    if (event.date_start) {
      event.date_start = moment.unix(event.date_start).format('YYYY-MM-DD');
    }

    if (event.date_end) {
      event.date_end = moment.unix(event.date_end).format('YYYY-MM-DD');
    }

    const timeFormat = Calendar.getTimeMomentFormat();

    // Establish default labels
    event.labels = {
      start_time: 'All Day',
      end_time: '',
      start_moment: moment(`${event.date_start} ${(event.time_start || '00:00 am')}`, 'YYYY-MM-DD ' + timeFormat),
      end_moment: moment(`${(event.date_end || event.date_start)} ${(event.time_end || '11:59 pm')}`, 'YYYY-MM-DD ' + timeFormat),
    };

    event.labels.YYYMMDD = event.labels.start_moment.format('YYYY-MM-DD');

    event.all_day = true;
    event.overnight = false;

    // Check for all day
    if (event.time_start) {
      event.labels.start_time = event.time_start;
      if (event.tbd_start === 't') {
        event.labels.start_time = 'TBD';
      } else if (event.labels.start_time === '12:00 pm' || event.labels.start_time === '12:00') {
        event.labels.start_time = 'Noon';
      } else if (event.labels.start_time === '12:00 am' || event.labels.start_time === '00:00') {
        event.labels.start_time = 'Midnight';
      }

      if (event.time_end) {
        event.labels.end_time = event.time_end;
        if (event.tbd_end === 't') {
          event.labels.end_time = 'TBD';
        } else if (event.labels.end_time === '12:00 pm' || event.labels.end_time === '12:00') {
          event.labels.end_time = 'Noon';
        } else if (event.labels.end_time === '12:00 am' || event.labels.end_time === '00:00') {
          event.labels.end_time = 'Midnight';
        }
      }
      event.all_day = false;
    }

    if (event.labels.YYYMMDD !== event.labels.end_moment.format('YYYY-MM-DD')) {
      event.overnight = true;
    }

    event.isLoading = false;
    event._isProcessed = true;

    events[id] = event;

    return Object.assign({}, state, { events });
  }

  case ActionTypes.EDIT_EVENT_LOAD_FAILURE: {
    console.error('Error loading event for edit', id, error);
    events[id] = { id, isLoading: false };

    return Object.assign({}, state, { events });
  }

  // case ActionTypes.EDIT_EVENT_PROCESS_REQUEST:
  //   events[id] = { id, isLoading: true };
  //
  //   return Object.assign({}, state, { events });
  //
  // case ActionTypes.EDIT_EVENT_PROCESS_SUCCESS: {
  //   events[id] = response.id ? response : { id };
  //
  //   return Object.assign({}, state, { events });
  // }
  //
  // case ActionTypes.EDIT_EVENT_PROCESS_FAILURE: {
  //   console.error('Error loading event for edit', id, error);
  //   events[id] = { id, isLoading: false };
  //
  //   return Object.assign({}, state, { events });
  // }

  default:
    return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/reducers/editEvent.js